import { Container } from '@mui/material';
import React from 'react';
import { Page } from '../../../components';
import HeaderBreadcrumbs from '../../../components/header-breadcrumbs';
import { TeamListView } from './team-list-view';

export const GroupsAndTeamsListPage: React.FC = () => {
    return (
        <Page title="Groups & Teams">
            <Container maxWidth={false}>
                <HeaderBreadcrumbs
                    heading="Groups & Teams"
                    links={[
                        {
                            name: '',
                            href: '/groups-and-teams'
                        },
                    ]}
                    activeLast={false}
                />
                <TeamListView />
            </Container>
        </Page>
    )
}
